require("./Comment.less");

const React = require("react");

const Comment = React.createClass({
    propTypes: {
        Comment: React.PropTypes.string.isRequired,
        OnChange: React.PropTypes.func.isRequired
    },

    getInitialState() {
        return {
            ShowCommentField: this.props.Comment !== ""
        };
    },

    render() {
        return (
            <footer>
                <div>
                    {!this.state.ShowCommentField &&
                    (<div className="cs-ShowComment">Would you like to enter a comment?
                        <button type="button" className="btn btn-Default cs-ShowComment__Button" onClick={this.showCommentField }>Enter Comment</button>
                    </div>)}
                </div>    
                <div>
                    {this.state.ShowCommentField && (
                    <div className="cs-Comment">
                        <label>Comment:</label>
                        <textarea className="form-control" onChange={this.props.OnChange}
                                  value={this.props.Comment} />
                    </div>)}
                </div>
                <div className="cs-Comment--print">
                    <label>Comment: </label>
                    <p>{this.PrintDisplayComment(this.props.Comment)}</p>
                </div>
            </footer>);
    },

    PrintDisplayComment(comment) {
        if (comment === "") {
            return (<em>No comment entered</em>);
        }
        else {
            return comment;
        }
    },

    showCommentField() {
        this.setState({
            ShowCommentField: true
        });
    }
});

module.exports = Comment;


// WEBPACK FOOTER //
// ./src/components/Comment/Comment.jsx